import {
    infoBoxShadow,
    infoColor,
    successLightColor,
    whiteColor,
    grayColor,
    blackColor,
} from '../global';

const SliderStyle = (theme) => ({
    wrapper: {
        backgroundColor: whiteColor,
    },
    sliderFirst: {
        maxWidth: '700px',
        margin: 'auto',
        borderRadius: '8px',
        // ...infoBoxShadow,
        borderColor: infoColor,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '360px',
    },
    imgstyle: {
        display: 'block',
        maxWidth: '100%',
        maxHeight: '360px',
        margin: 'auto',
    },

    styleDot: {
        height: 100,
        width: '76px',
        minWidth: '76px',
        margin: 10,
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '4px',
        borderColor: grayColor,
        borderStyle: 'solid',
        '&:hover,&:focus': {
            outline: 'none',
            borderRadius: '4px',
            borderColor: successLightColor,
            opacity: 0.8,
        },
        // [theme.breakpoints.down('md')]: {
        //     height: 80,
        //     width: 80,
        //     margin: 8,
        // },
        // [theme.breakpoints.down('xs')]: {
        //     height: 50,
        //     width: 50,
        //     margin: 5,
        // },
    },
    titleName: {
        overflow: 'hidden',
        margin: '10px',
        cursor: 'pointer',
        maxHeight: '150px',
        '&:hover,&:focus': {
            outline: 'none',
            opacity: 0.8,
            color: successLightColor,
        },
    },
    styleDotActive: {
        height: 100,
        minWidth: '76px',
        width: '76px',
        margin: 10,
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '4px',
        ...infoBoxShadow,
        borderColor: successLightColor,
        borderStyle: 'solid',
        opacity: 0.8,
        '&:hover,&:focus': {
            outline: 'none',
        },
        // [theme.breakpoints.down('md')]: {
        //     height: 80,
        //     width: 80,
        //     margin: 8,
        // },
        // [theme.breakpoints.down('xs')]: {
        //     height: 50,
        //     width: 50,
        //     margin: 5,
        // },
    },
    btnStyle: {
        fontSize: 14,
        minWidth: '100px',
        margin: '10px',
    },

    buttonBig: {
        fontSize: '30px !important',
        minWidth: '250px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '150px !important',
            margin: '10px  !important',
        },
    },
    btnShowCompanyInfo: {
        fontSize: '24px',
        borderRadius: '18px',
        fontWeight: 'bold',
        boxShadow: 'none',
        border: `2px solid ${blackColor}`,
        marginBottom: '36px',
        padding: '10px 25px',
    },
    divDot: {
        display: 'flex',
        '@media (min-width: 960px) and (max-width: 1200px)': {
            flexDirection: 'column',
        },
    },

    productSlider: {
        position: 'relative',
    },
    productSliderArrow: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        padding: 0,
        border: 0,
        outline: '0',
        backgroundColor: '#fff',
        cursor: 'pointer',
        zIndex: 1,

        '&:disabled': {
            opacity: '0.5',
            cursor: 'auto',
        }
    },
    productSliderNextArrow: {
        right: '0',
    },
    productSliderPrevArrow: {
        left: '0',
    },
    desc: {
        marginTop: '20px', 
        marginBottom: '20px', 

        [theme.breakpoints.up('md')]: {
            paddingLeft: '68px', 
            paddingRight: '68px',
        },
    },
});

export default SliderStyle;
